// src/components/CVNavbar.jsx
import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

export default function CVNavbar() {
  const [menuOpen, setMenuOpen] = useState(false);
  const [darkMode, setDarkMode] = useState(() => localStorage.getItem('theme') === 'dark');
  const location = useLocation();

  const navItems = [
    { label: 'Home', href: '/caravanbooking/home' },
    { label: 'Login', href: '/caravanbooking/login' },
    { label: 'Book Now', href: '/caravanbooking/book' },
    { label: 'My Bookings', href: '/caravanbooking/mybookings' }
  ];

  useEffect(() => {
    const root = document.documentElement;
    if (darkMode) {
      root.classList.add('dark');
      localStorage.setItem('theme', 'dark');
    } else {
      root.classList.remove('dark');
      localStorage.setItem('theme', 'light');
    }
  }, [darkMode]);

  const SunIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
      <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 2v2m6.364 1.636l-1.414 1.414M20 12h-2M17.364 17.364l-1.414-1.414M12 20v-2M6.636 17.364l1.414-1.414M4 12H2m3.636-6.364l1.414 1.414M12 6a6 6 0 100 12 6 6 0 000-12z" />
    </svg>
  );

  const MoonIcon = (
    <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
      <path d="M17.293 13.293a8 8 0 01-10.586-10.586A8 8 0 1017.293 13.293z" />
    </svg>
  );

  return (
    <nav className="fixed w-full z-50 bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 shadow transition-colors">
      <div className="max-w-7xl mx-auto px-6 py-4 flex items-center justify-between">
        <div className="flex-1 flex md:hidden">
          <button onClick={() => setMenuOpen(!menuOpen)} className="focus:outline-none" aria-label="Toggle menu">
            <div className={`flex flex-col justify-center items-center transform transition duration-300 ${menuOpen ? 'rotate-90' : ''}`}>
              <div className="w-6 h-0.5 bg-current mb-1" />
              <div className="w-6 h-0.5 bg-current mb-1" />
              <div className="w-6 h-0.5 bg-current" />
            </div>
          </button>
        </div>
        <div className="flex-1 flex justify-center">
          <div className="hidden md:flex space-x-8">
            {navItems.map(({ label, href }) => (
              <Link key={href} to={href} className={`hover:text-blue-600 transition ${location.pathname === href ? 'text-blue-600 font-semibold border-b-2 border-blue-600 pb-1' : ''}`}>{label}</Link>
            ))}
          </div>
        </div>
        <div className="flex-1 flex justify-end">
          <button onClick={() => setDarkMode(!darkMode)} className="p-2 border rounded-full hover:bg-gray-200 dark:hover:bg-gray-700 transition" aria-label="Toggle theme">
            {darkMode ? SunIcon : MoonIcon}
          </button>
        </div>
      </div>
      {menuOpen && (
        <div className="md:hidden bg-white dark:bg-gray-800 text-gray-800 dark:text-gray-100 px-6 pb-4">
          {navItems.map(({ label, href }) => (
            <Link key={href} to={href} className={`block py-2 hover:text-blue-600 transition ${location.pathname === href ? 'text-blue-600 font-semibold' : ''}`} onClick={() => setMenuOpen(false)}>{label}</Link>
          ))}
        </div>
      )}
    </nav>
  );
}